module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAmklEQVQoU42QwQ7BUBBF730bzSufw96efgPPD7BmyZYvEL5BrdnzNzRNa/GutEoikepsJnNzJpM5RFXZyA6N4UxQt4gIXr20Dnbp8TUDyCftJaT5e+mrk6vWNlkwG9sByfgnVIXyivhw4UlAvw4kcGbuwhuATh0I4N4QVNL8dKGFhoe/zzTW8xHubGTAqaReKZi8eK9NsE9LdU/DCEBjvWFHkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon009@2x.png
// module id = 32
// module chunks = 1